import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-slate-50 border-t border-gray-200 py-16 mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-3">
            <div className="h-8 w-8 rounded-lg bg-slate-900 flex items-center justify-center text-white font-semibold">I</div>
            <span className="font-medium text-lg tracking-tight">IdeSetGo</span>
          </div>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-3">Fra idé til gjennomarbeidet forretningsplan.</p>
          <p className="text-sm text-slate-500 max-w-sm leading-relaxed">
            En enkel og profesjonell måte å lage forretningsplan på - skreddersydd for norske gründere og småbedrifter.
          </p>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-4">Produkt</p>
          <ul className="space-y-3 text-sm text-slate-600">
            <li><a href="/#funksjoner" className="hover:text-slate-900">Funksjoner</a></li>
            <li><a href="/#priser" className="hover:text-slate-900">Priser</a></li>
            <li><a href="/#faq" className="hover:text-slate-900">FAQ</a></li>
          </ul>
        </div>
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-slate-500 mb-4">Selskap</p>
          <ul className="space-y-3 text-sm text-slate-600">
            <li><Link to="/login" className="hover:text-slate-900">Logg inn</Link></li>
            <li><Link to="/register" className="hover:text-slate-900">Registrer deg</Link></li>
            <li><a href="mailto:hei@idesetgo.no" className="hover:text-slate-900">Kontakt</a></li>
            <li><Link to="/vilkar" className="hover:text-slate-900" data-testid="footer-terms">Vilkår</Link></li>
            <li><Link to="/personvern" className="hover:text-slate-900" data-testid="footer-privacy">Personvern</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between gap-4 text-sm text-slate-500">
        <p>© {new Date().getFullYear()} IdeSetGo. Alle rettigheter forbeholdt.</p>
        <p>Laget i Norge med omtanke for gründere.</p>
      </div>
    </footer>
  );
}
